import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ROLE_LABEL } from "@/lib/roles";

/** Shown inside the shell when a staff member opens a page their role can't use. */
const ForbiddenPanel = ({ requiredRoles }: { requiredRoles: readonly number[] }) => {
  const names = requiredRoles.map((id) => ROLE_LABEL[id] ?? `Role ${id}`);
  return (
    <section aria-labelledby="forbidden-title" className="mx-auto mt-16 max-w-lg rounded-2xl border bg-card p-8 text-center">
      <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-secondary flex items-center justify-center text-ink-2">
        <Lock className="h-5 w-5" aria-hidden="true" />
      </div>
      <h1 id="forbidden-title" className="font-serif text-2xl font-semibold">
        Your role can't open this page
      </h1>
      <p className="mt-2 text-sm text-ink-2">
        It's for {names.join(", ").replace(/, ([^,]*)$/, " or $1")}. Ask a Super Admin if you need it.
      </p>
      <Button asChild variant="outline" className="mt-6 rounded-xl">
        <Link to="/admin/today">Back to Today</Link>
      </Button>
    </section>
  );
};

export default ForbiddenPanel;
